import axios from "axios";
import { ApiService } from "./api.service";

export type TUserAssetEntityType = "USER_AVATAR" | "USER_COVER";

export interface IUserAssetPresignedResponse {
  upload_data: {
    url: string;
    fields?: Record<string, string>;
    method?: "PUT" | "POST";
  };
  asset_id: string;
  asset_url: string;
}

interface ICreateUserAssetPayload {
  entity_type: TUserAssetEntityType;
  name: string;
  type: string;
  size: number;
}

export class UserAssetService extends ApiService {
  async createAsset(data: ICreateUserAssetPayload): Promise<IUserAssetPresignedResponse> {
    return this.post(`/api/assets/v2/user-assets/`, data);
  }

  async uploadToPresignedUrl(
    presigned: IUserAssetPresignedResponse["upload_data"],
    file: File,
  ): Promise<void> {
    if (presigned.method === "PUT") {
      await axios.put(presigned.url, file, { headers: { "Content-Type": file.type } });
      return;
    }
    const formData = new FormData();
    Object.entries(presigned.fields ?? {}).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("file", file);
    await axios.post(presigned.url, formData);
  }

  async markUploaded(assetId: string): Promise<void> {
    return this.patch(`/api/assets/v2/user-assets/${assetId}/`);
  }

  async deleteAsset(assetId: string): Promise<void> {
    return this.delete(`/api/assets/v2/user-assets/${assetId}/`);
  }

  async uploadUserImage(
    entityType: TUserAssetEntityType,
    file: File,
  ): Promise<IUserAssetPresignedResponse> {
    const presigned = await this.createAsset({
      entity_type: entityType,
      name: file.name,
      type: file.type || "image/jpeg",
      size: file.size,
    });
    await this.uploadToPresignedUrl(presigned.upload_data, file);
    await this.markUploaded(presigned.asset_id);
    return presigned;
  }
}
